export default "__VITE_ASSET__mQ9hDdtd__"